import axios from 'axios';
import seed from '../../public/portal-content-template.json';
import { preparePortalValue } from './content.mjs';

let snapshot = seed.content;
export const portalStatus = { preview: false, previewError: '', revision: null, fallback: true };
const mediaFields = seed.definition.pages.find(page => page.key === 'media').fields;
const assets = Object.fromEntries(mediaFields.map(field => ['asset:' + field.assetKey, field]));
const has = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);

export function portalImage(reference, visited = new Set()) {
  if (typeof reference !== 'string') return '';
  if (/^media:[a-f0-9]{32}$/.test(reference)) return '/portal-api/image?key=' + reference.slice(6);
  const field = assets[reference];
  if (!field || visited.has(reference)) return '';
  const replacement = snapshot.media && snapshot.media[field.key];
  // An explicit empty value removes the shared asset; a missing override keeps the original.
  if (replacement === '') return '';
  if (replacement && replacement !== reference) { visited.add(reference); return portalImage(replacement, visited); }
  return '/portal-assets/' + field.assetKey.split('/').map(encodeURIComponent).join('/');
}

export function portalData(scope, defaults) {
  const definition = seed.definition.pages.find(page => page.key === scope);
  if (!definition) return defaults;
  const values = snapshot[scope] || seed.content[scope];
  for (const field of definition.fields) {
    if (has(defaults, field.key)) defaults[field.key] = preparePortalValue(has(values, field.key) ? values[field.key] : seed.content[scope][field.key], portalImage);
  }
  if (scope === 'aboutdpp' && defaults.cards && defaults.cards[0]) defaults.imageCardShow = defaults.cards[0].cardItemImg;
  return defaults;
}

async function request(path, data) {
  const response = data ? await axios.post('/portal-api' + path, data, { timeout: 5000 }) : await axios.get('/portal-api' + path, { timeout: 3000 });
  if (!response.data || response.data.code !== 0) throw new Error(response.data && response.data.msg || '门户内容暂时无法读取');
  return response.data.data;
}

export async function loadPortalContent() {
  if (window.__PRERENDER_INJECTED) return;
  let token = '';
  try {
    const match = window.location.hash.match(/^#portal-preview=([a-f0-9]{32})$/);
    if (match) { token = match[1]; sessionStorage.setItem('portal-preview-token', token); history.replaceState(null, '', location.pathname + location.search); }
    token = token || sessionStorage.getItem('portal-preview-token') || '';
    const result = token ? await request('/preview', { token }) : await request('/content');
    if (token && !result.preview) throw new Error('草稿预览未成功，请回到管理后台重新预览');
    if (result.initialized && result.content) { snapshot = result.content; portalStatus.fallback = false; portalStatus.revision = result.revision; }
    portalStatus.preview = Boolean(token);
  } catch (error) {
    if (token) { portalStatus.preview = true; portalStatus.previewError = error.message || '预览已过期，请重新预览'; }
  }
  for (const field of mediaFields) {
    const reference = snapshot.media && snapshot.media[field.key];
    if (reference === '') document.documentElement.style.setProperty(field.cssVariable, 'none');
    else if (reference && reference !== 'asset:' + field.assetKey) {
      const resolved = portalImage(reference);
      document.documentElement.style.setProperty(field.cssVariable, resolved ? `url("${resolved}")` : 'none');
    }
    else document.documentElement.style.removeProperty(field.cssVariable);
  }
}

export function installPortal(Vue) {
  Vue.prototype.$portalStatus = portalStatus;
  Vue.prototype.$portalPreview = portalStatus.preview;
  Vue.prototype.$portalText = (scope, key) => {
    const values = snapshot[scope];
    return has(values, key) ? values[key] : seed.content[scope] && seed.content[scope][key] || '';
  };
  Vue.prototype.$exitPortalPreview = () => { sessionStorage.removeItem('portal-preview-token'); window.location.reload(); };
}
